import React, { ReactElement, useState } from 'react'
import { Button, Typography } from '@mui/material'

import { TrashIcon } from '~assets/icons'
import ConfirmDeleteModal from '~components/common/ConfirmDeleteModal'
import { lightTheme } from '~createTheme'

interface DeleteButtonProps<T> {
  item: T
  onDelete: (item: T) => void
  itemName?: string
  isDisabled?: boolean
  warningMessage?: string
  buttonSize?: 'small' | 'medium' | 'large'
  showLabel?: boolean
  modalTitle?: string
}

function DeleteButton<T>({
  item,
  onDelete,
  itemName,
  isDisabled = false,
  warningMessage,
  buttonSize = 'large',
  showLabel = false,
  modalTitle = 'Confirm Deletion',
}: DeleteButtonProps<T>): ReactElement {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleDeleteClick = (e: React.MouseEvent): void => {
    e.stopPropagation()
    setIsModalOpen(true)
  }

  const handleCloseModal = (): void => {
    setIsModalOpen(false)
  }

  const handleConfirmDelete = (): void => {
    onDelete(item)
    setIsModalOpen(false)
  }

  return (
    <>
      <Button size={buttonSize} onClick={handleDeleteClick} disabled={isDisabled} variant='text'>
        <TrashIcon
          color={isDisabled ? lightTheme.palette.grey[400] : lightTheme.palette.text.primary}
        />
        {showLabel && (
          <Typography
            variant='body2'
            color={isDisabled ? lightTheme.palette.grey[400] : lightTheme.palette.text.primary}
          >
            {itemName ? `Delete ${itemName}` : 'Delete'}
          </Typography>
        )}
      </Button>

      <ConfirmDeleteModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleConfirmDelete}
        title={modalTitle}
        description={warningMessage}
        itemName={itemName}
      />
    </>
  )
}

export default DeleteButton
